// src/components/RatingComponent.jsx - Componente de Rating actualizado MUI v5+
import React from 'react';
import { Box, Typography, Rating } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const RatingComponent = ({ value = 4.5, cantidad = 128, readOnly = true }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 0.5,
        py: 1
      }}
    >
      <Rating
        name="user-rating"
        value={value}
        readOnly={readOnly}
        precision={0.5}
        icon={<StarIcon fontSize="inherit" sx={{ color: '#FFD700' }} />}
        emptyIcon={<StarBorderIcon fontSize="inherit" sx={{ color: '#FFD700' }} />}
        sx={{
          fontSize: '1.8rem',
          '& .MuiRating-iconFilled': {
            color: '#FFD700'
          },
          '& .MuiRating-iconHover': {
            color: '#FFC107'
          }
        }}
      />
      {cantidad !== null && cantidad !== undefined && (
        <Typography 
          variant="caption" 
          sx={{ 
            color: '#757575',
            fontWeight: 500,
            fontSize: '0.75rem'
          }}
        >
          ({cantidad} {cantidad === 1 ? 'valoración' : 'valoraciones'})
        </Typography>
      )}
      <Typography
        variant="body2"
        sx={{
          color: '#424242',
          fontWeight: 600,
          fontSize: '0.9rem'
        }}
      >
        {value.toFixed(1)} / 5.0
      </Typography>
    </Box>
  );
};

export default RatingComponent;